<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <transition name="fade">
          <b-card
            border-variant="info"
            header-bg-variant="primary"
            header-text-variant="white"
            class="card-wrap"
            style="min-height: 400px"
          >
            <component-new-header
              title="Item Details"
              :hasSearch="false"
              :hasReload="false"
              :hasRadio="false"
              :hasCreate="false"
              :hasback="false"
            />
            <b-row>
              <b-col md="11" class="my-1">
                <b-row>
                  <b-col md="6">
                    <b-form-group label-cols-sm="3" class="mb-0">
                      <eb-select
                        type="text"
                        :options="stockOptions"
                        label="label"
                        placeholder="Select Warehouse"
                        @input="changeStockpoint"
                      ></eb-select>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group label-cols-sm="3" class="mb-0">
                      <eb-select
                        type="text"
                        :options="itemList"
                        label="label"
                        placeholder="Select Item"
                        @input="changeItem"
                      ></eb-select>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="1" class="my-1">
                <b-button
                  variant="primary"
                  @click="getStockStatus"
                  :disabled="!itemId || itemId === ''"
                  >GO
                </b-button>
              </b-col>
            </b-row>

            <div class="mt-3" v-if="stocksData.length > 0">
              <b-table
                :dark="false"
                :hover="true"
                :striped="striped"
                :bordered="bordered"
                :small="small"
                :fixed="fixed"
                :items="stocksData"
                responsive="sm"
                id="my-table"
                :current-page="currentPage"
                :per-page="perPage"
                thead-class="header"
                class="mt-3"
                :fields="Columns"
              ></b-table>
            </div>
            <div style="float: right" v-if="stocksData.length > 0">
              <b-col md="2" class="my-1">
                <b-button variant="primary" @click="downloadStock"
                  >Download</b-button
                >
              </b-col>
            </div>
          </b-card>
        </transition>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Vue, Component, Prop } from "vue-property-decorator";
import { mapActions } from "vuex";
import ebSelect from "@/components/FormElements/Select";
import loader from "@/components/loader/nipigeloader.vue";
import { getPartnerParentData } from "@/services/partner";
import componentNewHeader from "@/components/componentNewHeader";
export default {
  name: "LoadInventory",
  components: {
    ebSelect,
    loader,
    componentNewHeader,
  },
  data: () => {
    return {
      perPage: 10,
      striped: false,
      bordered: true,
      small: false,
      fixed: false,
      currentPage: 1,
      loading: false,
      itemId: "",
      selectedItem: {},
      items: "",
      stockPointId: "",
      stocksData: [],
      Columns: [
        {
          key: "ITEM NAME",
        },
        {
          key: "TOTAL STOCK",
        },
        {
          key: "BOOKED",
        },
        {
          key: "AVAILABLE",
        },
        {
          key: "DELIVERED",
        },
        {
          key: "RETURNED",
        },
        {
          key: "EXPIRED",
        },
      ],
    };
  },
  methods: {
    ...mapActions({
      GetStockpoints: "partner/fetchStockpointsByTenant",
      GetItems: "item/fetchItemsByCatalog",
      GetItemStockStatus: "inventory/getItemStockStatus",
      DownloadStockStatus: "inventory/getItemStockDownload",
    }),
    async changeStockpoint(data) {
      if (data !== null) {
        this.loading = true;
        let payload = { needInventory: true };
        const stockpointParentData = await getPartnerParentData(data._id).then(
          (x) => x.response
        );
        if (this.userCategory === "MANUFACTURER") {
          payload.manufacturerId = this.$store.getters["auth/getUserID"];
        } else {
          payload.provider = stockpointParentData._id;
        }
        this.stockPointId = data._id;
        this.GetItems(payload)
          .then(() => (this.loading = false))
          .catch(() => (this.loading = false));
      }
    },
    changeItem(data) {
      this.itemId = data._id;
      this.selectedItem = data;
    },
    getStockStatus() {
      this.loading = true;
      this.stocksData = [];
      this.GetItemStockStatus({
        id: this.selectedItem._id,
        data: { stockPointId: this.stockPointId },
      })
        .then((res) => {
          this.loading = false;
          if (res.inventoryStatus && res.inventoryStatus.length) {
            let object = {
              ["ITEM NAME"]: this.selectedItem.label,
              ["TOTAL STOCK"]: 0,
            };
            res.inventoryStatus.map((Obj) => {
              object[Obj.state] = Obj.count;
            });
            object["TOTAL STOCK"] =
              object.BOOKED +
              object.AVAILABLE +
              object.EXPIRED +
              object.ON_REPAIR +
              object.DELIVERED +
              object.RETURNED;
            this.stocksData.push(object);
          } else if (res.response && res.response.length) {
            res.response.map((x) => {
              let object = {
                ["ITEM NAME"]: x.name,
                ["TOTAL STOCK"]: 0,
                LOCKED: 0,
                BOOKED: 0,
                EXPIRED: 0,
                AVAILABLE: 0,
                DELIVERED: 0,
                RETURNED: 0,
              };
              x.details.map((x) => {
                object[x.state] = x.count;
              });
              object["TOTAL STOCK"] = object.BOOKED + object.AVAILABLE;
              this.stocksData.push(object);
            });
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    downloadStock() {
      this.DownloadStockStatus(this.itemId).then((res) => {
        window.open(res.downloadUrl);
      });
    },
  },
  computed: {
    stockOptions() {
      let data = this.$store.getters["partner/GetAllStockPointList"];
      let userId = this.$store.getters["auth/getUserID"];
      if (data.length > 0) {
        let stockpoints = data.map((obj) => ({
          _id: obj._id,
          providerId: userId,
          label: obj.office?.officeName || "",
        }));
        return stockpoints;
      } else {
        return [];
      }
    },
    itemList() {
      let data = this.$store.getters["item/GetItemListByCatalog"];
      if (data.length > 0) {
        let items = [];
        data.map((obj) => {
          items.push({
            _id: obj._id,
            label: obj.description_summary,
          });
        });
        items.unshift({ label: "All", _id: "all" });
        return items;
      } else {
        return [];
      }
    },
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
    userCategory() {
      return JSON.parse(sessionStorage.getItem("userLogin"))["category"];
    },
  },
  async mounted() {
    await this.$store.dispatch("partner/fetchAllStockPointTenant");
  },
};
</script>
<style lang="sass" scoped>
.edit
  color: white !important

.text-center
  text-align: center

.form-div label
  margin-top: 8px
</style>
